import { CheckBadgeIcon, ClipboardDocumentCheckIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { getYear } from 'date-fns';
import React from "react";
import { connect } from 'react-redux';
import Tooltip from "@/tooltip";
import { Actions as EMPLOYEEACTIONS } from '../../../../store/actions/employeeActions';
import Spinner from '../../../common/Spinner';
import COLAEmployeeRow from "./COLAEmployeeRow";

const ColaModal = ({
    isModalOpen,
    closeModal,
    openModal,
    applyCola,
    employees,
    setColaRounding,
    colaRoundingEnabled,
    applyingCola,
    colaApplied,
    isValid,
    colaRequired,
    colaPreApplied,
    setColaPreApplied,
    firstPayroll,
    referenceDate,
    periodStart,
    applyFirstPeriod,
    isAdmin,
    setColaFirstInPeriod
}) => {
    if ((!colaRequired && !colaApplied) || (!isModalOpen && colaApplied)) return null

    const year = getYear(new Date(referenceDate))

    if (!isModalOpen && colaRequired) return (
        <div className="content bg-primary">
            <p className="font-w600" style={{ color: "#fff" }}>Cost of Living Adjustment for {year} has not yet been applied.</p>
            <div className="btn btn-success pull-right" onClick={openModal}>
                <ClipboardDocumentCheckIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                <div style={{ float: "left" }}>Review</div>
            </div>
            <div className="clearfix" />
        </div>
    )

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div className="modal-dialog" style={{ width: "75%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20, position: 'sticky', top: 0, zIndex: 50 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={closeModal}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Cost of Living Adjustment {year}</h3>
                        </div>
                        <div className="col-xs-12 pl-0" style={{ marginTop: '2rem', marginBottom: '2rem', background: 'white' }}>
                            <div className="col-xs-6">
                                <div className="form-material">
                                    <label className="css-input switch switch-sm switch-success">
                                        <input
                                            onChange={setColaRounding}
                                            checked={colaRoundingEnabled}
                                            type="checkbox"
                                        />
                                        <span></span>
                                        <label htmlFor="material-text" style={{ marginBottom: 0 }}>
                                            Round up to 2 Decimal Places
                                        </label>
                                    </label>
                                    <div className="clearfix" />
                                </div>
                            </div>
                            {periodStart &&
                                <div className="col-xs-6">
                                    <div className="form-material">
                                        <label className="css-input switch switch-sm switch-success">
                                            <input
                                                onChange={setColaFirstInPeriod}
                                                checked={applyFirstPeriod}
                                                type="checkbox"
                                            />
                                            <span></span>
                                            <label htmlFor="material-text" style={{ marginBottom: 0 }}>
                                                <Tooltip content="Enabling this option will set their COLA from the start date of the first period in the year. Any employees that fall under a period which start date starts after 1st January will still be defaulted to 1st January">
                                                    Apply from Start of 1st Period
                                                </Tooltip>
                                            </label>
                                        </label>
                                        <div className="clearfix" />
                                    </div>
                                </div>
                            }
                            {(isAdmin || firstPayroll) &&
                                <div className="col-xs-6" style={{ marginTop: '1rem' }}>
                                    <div className="form-material">
                                        <label className="css-input switch switch-sm switch-success">
                                            <input
                                                onChange={setColaPreApplied}
                                                checked={colaPreApplied}
                                                type="checkbox"
                                            />
                                            <span></span>
                                            <label htmlFor="material-text" style={{ marginBottom: 0 }}>
                                                <Tooltip content="When starting to use Buddy, you may have imported or inserted salaries that include COLA. Choose this option if your salaries already include the Cost of Living Adjustment.">
                                                    COLA was already applied on Salaries Provided
                                                </Tooltip>
                                            </label>
                                        </label>
                                        <div className="clearfix" />
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-xs-12" style={{ overflow: "auto" }}>
                            <table className="js-table-sections table table-hover">
                                <thead>
                                    <tr>
                                        <th>NAME</th>
                                        <th>D.O.E</th>
                                        <th>EMP. TYPE</th>
                                        <th>CURRENT SALARY</th>
                                        <th>NEW SALARY</th>
                                        <th>SALARY INCREASE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employees.map(employee => (<COLAEmployeeRow key={employee.employee} employee={employee} year={year} />))}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-xs-12" style={{ marginBottom: '2rem' }}>
                            <div
                                className={`btn ${isValid ? 'btn-success' : 'btn-danger'} pull-right`}
                                onClick={() => isValid && !applyingCola && applyCola()}
                            >
                                {applyingCola ?
                                    <Spinner
                                        style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                        className="animate-spin -ml-1 mr-3 h-5 w-5 "
                                    />
                                    :
                                    isValid ?
                                        <CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                        :
                                        <ExclamationTriangleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                }
                                <div style={{ float: "left" }}>
                                    {applyingCola ? 'Applying Cost of Living' : isValid ? 'Apply Cost of Living' : 'Invalid Cost of Living Adjustments'}
                                </div>
                            </div>
                        </div>
                        <div className="clearfix" />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    const isValid = !Object.keys(state.cola?.salaries || {}).find(i => !state.cola?.salaries?.[i]?.valid)

    return {
        departments: state.company?.settings?.departments?.map(department => ({
            label: department.name,
            value: department.id
        })),
        isModalOpen: state.cola?.isModalOpen,
        employees: state.cola?.sortedEmployees?.length > 100 ? state.cola?.sortedEmployees?.splice(100, state.cola?.sortedEmployees?.length - 100) : state.cola?.sortedEmployees,
        colaRequired: state.cola?.colaRequired,
        firstPayroll: state.cola?.firstPayroll,
        referenceDate: state.cola?.referenceDate,
        colaRoundingEnabled: !!state.cola?.rounding,
        colaPreApplied: !!state.cola?.preApplied,
        applyFirstPeriod: !!state.cola?.applyFirstPeriod,
        periodStart: state.cola?.periods?.length > 0,
        applyingCola: state.cola?.applyingCola,
        colaApplied: state.cola?.colaApplied,
        isValid,
        isAdmin: state.my?.profile?.isAdmin,
    };
};

const mapDispatchToProps = dispatch => ({
    setColaRounding: () => dispatch(EMPLOYEEACTIONS.setColaRounding()),
    setColaPreApplied: () => dispatch(EMPLOYEEACTIONS.setColaPreApplied()),
    setColaFirstInPeriod: () => dispatch(EMPLOYEEACTIONS.setColaFirstInPeriod()),
    applyCola: () => dispatch(EMPLOYEEACTIONS.applyCola()),
    closeModal: () => dispatch(EMPLOYEEACTIONS.showCOLAModal(false)),
    openModal: () => dispatch(EMPLOYEEACTIONS.showCOLAModal(true)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ColaModal)